import React from "react";

function Terms() {
  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms of Service</h1>
      <p>Last Updated: May 30, 2025</p>
      
      <h2>1. Acceptance of Terms</h2>
      <p>By accessing and using our prayer assistance service, you accept and agree to be bound by the terms and provision of this agreement.</p>
      
      <h2>2. Use of Service</h2>
      <p>Our service is provided for personal, spiritual, and educational purposes. You agree to use the service responsibly and in accordance with your religious beliefs and practices.</p>
      
      <h2>3. Content and Conduct</h2>
      <p>You are responsible for any content you submit through our service. We reserve the right to remove content that is inappropriate, offensive, or violates these terms.</p>
      
      <h2>4. Privacy</h2>
      <p>Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your information.</p>
      
      <h2>5. Limitation of Liability</h2>
      <p>Our service is provided "as is" without warranties of any kind. We shall not be liable for any damages arising from your use of the service.</p>
      
      <h2>6. Changes to Terms</h2>
      <p>We may update these Terms from time to time. We will notify you of any changes by posting the new Terms on this page.</p>
      
      <h2>7. Contact Us</h2>
      <p>If you have any questions about these Terms of Service, please contact us at founders@naturalui.com.</p>
    </div>
  );
}

export default Terms; 